import { Stack } from "@mui/material";
import { isValidElement, ReactNode, RefObject } from "react";
import { Element, ElementToPrint } from "./element";
import { RowsElement, RowsElementProps } from "./rows-element";
type PrintContentProps = {
  fontSizeDefault?: string;
  elements: ElementToPrint[] | ReactNode;
  rowsElement?: RowsElementProps;
  innerRef?: RefObject<HTMLDivElement> | null;
};
export const PrintContent = ({
  elements,
  fontSizeDefault,
  innerRef,
  rowsElement,
}: PrintContentProps) => {
  return (
    <Stack
      ref={innerRef}
      sx={{
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
      }}
    >
      {isValidElement(elements)
        ? elements
        : (elements as ElementToPrint[]).map((x) => {
            if (!x.fontSize) {
              x.fontSize = fontSizeDefault || "inherit";
            }
            return <Element key={`${x.left}-${x.top}`} element={x}></Element>;
          })}

      {rowsElement ? <RowsElement {...rowsElement}></RowsElement> : undefined}
    </Stack>
  );
};
